import { EpimsBaseEntityDto } from './epim-base.dto';
export class LineOfBusinessDto extends EpimsBaseEntityDto {

    LineOfBusinessId: string;

    LineOfBusinessName: string;

   

}